@if (targetedSubscribers$ | async) {
  <div
    class="relative rounded border border-[rgba(37,37,37,0.04)] border-solid mb-[15px]"
  >
    <div class="flex flex-row items-center">
      <div class="flex flex-row items-center justify-between p-3 w-full">
        <!-- Left section: Title and total count -->
        <div class="flex flex-col items-start justify-start">
          <div class="flex flex-col font-normal justify-center">
            <p class="block font-bold leading-normal text-black">
              {{ 'notification-targeted-subscribers.total' | translate }}
            </p>
          </div>
          <div class="flex flex-col font-bold justify-center text-brand text-2xl">
            <p class="block leading-normal">
              {{
                (targetedSubscribers$ | async).ios +
                  (targetedSubscribers$ | async).android | number
              }}
            </p>
          </div>
        </div>

        <!-- Right section: Platform breakdown -->
        <div class="flex flex-col items-end justify-start">
          <!-- iOS row -->
          <div class="flex flex-row gap-2 items-center justify-start">
            <div
              class="flex flex-col font-normal justify-center leading-none text-left whitespace-nowrap"
            >
              <p class="leading-normal text-xs text-black whitespace-pre">
                <span class="font-bold">{{
                  (targetedSubscribers$ | async).ios | number
                }}</span>
                <span> {{ 'notification-targeted-subscribers.ios' | translate }}</span>
              </p>
            </div>
            <div class="overflow-hidden w-3 h-3 flex items-center justify-center">
              <fa-icon class="text-black opacity-20 text-xs" [icon]="['fab', 'apple']">
              </fa-icon>
            </div>
          </div>

          <!-- Android row -->
          <div class="flex flex-row gap-2 items-center justify-start">
            <div
              class="flex flex-col font-normal justify-center leading-none text-left whitespace-nowrap"
            >
              <p class="leading-normal text-xs text-black whitespace-pre">
                <span class="font-bold">{{
                  (targetedSubscribers$ | async).android | number
                }}</span>
                <span>
                  {{ 'notification-targeted-subscribers.android' | translate }}</span
                >
              </p>
            </div>
            <div class="overflow-hidden w-3 h-3 flex items-center justify-center">
              <fa-icon class="text-black opacity-20 text-xs" [icon]="['fab', 'android']">
              </fa-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
